import { Environment } from '@src/config/environment';

export function getDownloadUrl(fileId: string): string {
  return `${Environment.DIRECTUS_API_URL}/assets/${fileId}`;
}
